import { VirtualSetEqualsIcon } from 'components/Pages/ProductDetail/VirtualSet/VirtualSetEqualsIcon';
import { VirtualSetPlusIcon } from 'components/Pages/ProductDetail/VirtualSet/VirtualSetPlusIcon';
import { VirtualSetProduct } from 'components/Pages/ProductDetail/VirtualSet/VirtualSetProduct';
import { VirtualSetSummary } from 'components/Pages/ProductDetail/VirtualSet/VirtualSetSummary';
import useTranslation from 'next-translate/useTranslation';
import { Fragment, useEffect, useState } from 'react';
import { VirtualSetProductType } from 'types/product';
import { VirtualSetType } from 'types/virtualSet';

type VirtualSetProps = {
    virtualSet: VirtualSetType;
};

export const VirtualSet: FC<VirtualSetProps> = ({ virtualSet }) => {
    const { t } = useTranslation();
    const [includedProducts, setIncludedProducts] = useState<Map<string, VirtualSetProductType>>(
        new Map(virtualSet.products.map((product) => [product.uuid, product])),
    );

    const productsCount = virtualSet.products.length;

    const onIsProductWantedToggle = (product: VirtualSetProductType, isProductWanted: boolean) => {
        setIncludedProducts((prev) => {
            const next = new Map(prev);
            if (isProductWanted) {
                next.set(product.uuid, product);
            } else {
                next.delete(product.uuid);
            }

            return next;
        });
    };

    useEffect(() => {
        setIncludedProducts(new Map(virtualSet.products.map((product) => [product.uuid, product])));
    }, [virtualSet.products]);

    if (productsCount < 2) {
        return null;
    }

    return (
        <div className="pb-5">
            <h3 className="hidden vl:block">{t('Everything matches in this set:')}</h3>
            <div className="flex flex-col items-stretch vl:flex-row">
                <div className="flex flex-1 flex-col items-center gap-2 md:flex-row md:flex-wrap md:items-stretch">
                    {virtualSet.products.map((product, index) => (
                        <Fragment key={product.uuid}>
                            <VirtualSetProduct
                                isProductWantedInSet={includedProducts.has(product.uuid)}
                                product={product}
                                onIsProductWantedToggle={(uuid, wanted) => onIsProductWantedToggle(product, wanted)}
                            />
                            <div className="flex items-center">
                                {index !== productsCount - 1 && <VirtualSetPlusIcon />}
                            </div>
                        </Fragment>
                    ))}
                </div>
                <div className="flex shrink-0 items-center justify-center p-2 lg:px-2 vl:px-3">
                    <VirtualSetEqualsIcon />
                </div>
                <div className="flex w-full shrink-0 items-center vl:w-[468px] [&>*:last-child]:mb-0">
                    <VirtualSetSummary includedProducts={Array.from(includedProducts.values())} />
                </div>
            </div>
        </div>
    );
};
